// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2185f","overflowing":"ReadFullNote_overflowing__2ossR"};